import { render, staticRenderFns } from "./airesult.vue?vue&type=template&id=6fa0b426"
import script from "./airesult.vue?vue&type=script&lang=js"
export * from "./airesult.vue?vue&type=script&lang=js"
import style0 from "./airesult.vue?vue&type=style&index=0&id=6fa0b426&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports